import Vue from 'vue';
import Router from 'vue-router';

import Home from './components/home.vue';
import Dashboard from './components/dashboard.vue';

import Clients from './components/clients/index.vue';

import ClientCreate from './components/clients/create.vue';

import Client from './components/clients/client/index.vue';

import Players from './components/clients/client/players/index.vue';
import PlayersList from './components/clients/client/players/list.vue';
import Player from './components/clients/client/players/player/index.vue';
import PlayerGeneral from './components/clients/client/players/player/general.vue';
import PlayerTransactions from './components/clients/client/players/player/transactions.vue';
import PlayerPins from './components/clients/client/players/player/pins.vue';
import PlayerTransBets from './components/clients/client/players/player/trans-bets.vue';
import PlayerHdRacesBets from './components/clients/client/players/player/hdraces-bets.vue';
import PlayerBkBets from './components/clients/client/players/player/bk-bets.vue';
import CreatePlayer from './components/clients/client/players/player/create.vue';
import CreateBalance from './components/clients/client/players/player/create-balance.vue';

import ClientWarnTransactions from './components/clients/client/warn-transactions.vue';

import ClientPins from './components/clients/client/pins.vue';

import ClientBets from './components/clients/client/bets/index.vue';
import ClientTransBets from './components/clients/client/bets/trans-bets.vue';
import ClientHdRacesBets from './components/clients/client/bets/hdraces-bets.vue';
import ClientBkBets from './components/clients/client/bets/bk-bets.vue';

import ClientSettings from './components/clients/client/settings/index.vue';
import ClientSettingsGeneral from './components/clients/client/settings/general.vue';

import ClientSettingsView from './components/clients/client/settings/view/index.vue';
import ClientSettingsViewAnalytics from './components/clients/client/settings/view/analytics.vue';
import ClientSettingsViewAuth from './components/clients/client/settings/view/auth.vue';
import ClientSettingsViewBanners from './components/clients/client/settings/view/banners.vue';
import ClientSettingsViewBk from './components/clients/client/settings/view/bk.vue';
import ClientSettingsViewBot from './components/clients/client/settings/view/bot.vue';
import ClientSettingsViewGeneral from './components/clients/client/settings/view/general.vue';
import ClientSettingsViewLanguage from './components/clients/client/settings/view/language.vue';
import ClientSettingsViewLegal from './components/clients/client/settings/view/legal.vue';
import ClientSettingsViewMenu from './components/clients/client/settings/view/menu.vue';
import ClientSettingsViewMobile from './components/clients/client/settings/view/mobile.vue';
import ClientSettingsViewPayments from './components/clients/client/settings/view/payments.vue';
import ClientSettingsViewPlayerActivity from './components/clients/client/settings/view/player-activity.vue';
import ClientSettingsViewProfile from './components/clients/client/settings/view/profile.vue';
import ClientSettingsViewRouting from './components/clients/client/settings/view/routing.vue';
import ClientSettingsViewStyle from './components/clients/client/settings/view/style.vue';
import ClientSettingsViewSweepstakes from './components/clients/client/settings/view/sweepstakes.vue';

import ClientSettingsBonuses from './components/clients/client/settings/bonuses/index.vue';
import ClientSettingsBonusRulesContent from './components/clients/client/settings/bonuses/rules-content.vue';
import ClientSettingsCashbackBonus from './components/clients/client/settings/bonuses/cashback.vue';
import ClientSettingsRegistrationBonus from './components/clients/client/settings/bonuses/registration.vue';
import ClientSettingsWelcomeBonus from './components/clients/client/settings/bonuses/welcome.vue';
import ClientSettingsDepositBonus from './components/clients/client/settings/bonuses/deposit.vue';
import ClientSettingsCouponBonus from './components/clients/client/settings/bonuses/coupon.vue';

import ClientSettingsCuracao from './components/clients/client/settings/curacao.vue';
import ClientSettingsGcb from './components/clients/client/settings/gcb.vue';
import ClientSettingsMessengers from './components/clients/client/settings/messengers.vue';
import ClientSettingsRedPipe from './components/clients/client/settings/redpipe.vue';
import ClientSettingsFlg from './components/clients/client/settings/flg.vue';
import ClientSettingsHdRaces from './components/clients/client/settings/hdraces.vue';
import ClientSettingsBk from './components/clients/client/settings/bk.vue';
import ClientSettingsRegistration from './components/clients/client/settings/registration.vue';
import ClientSettingsLogin from './components/clients/client/settings/login.vue';
import ClientSettingsSupport from './components/clients/client/settings/support.vue';
import ClientSettingsTvbet from './components/clients/client/settings/tvbet.vue';
import ClientSettingsSoftGamings from './components/clients/client/settings/softgamings.vue';
import ClientSettingsKomplexBridge from './components/clients/client/settings/komplexbridge.vue';
import ClientSettingsAviatrix from './components/clients/client/settings/aviatrix.vue';
import ClientSettingsPaymentSystem from './components/clients/client/settings/payment-system.vue';
import ClientSettingsWinningStats from './components/clients/client/settings/winning-stats.vue';
import ClientSettingsKra from './components/clients/client/settings/kra.vue';
import ClientSettingsGalaxsys from './components/clients/client/settings/galaxsys.vue';
import ClientSettingsSmartsoft from './components/clients/client/settings/smartsoft.vue';
import ClientSettingsVegas from './components/clients/client/settings/vegas.vue';
import ClientSettingsMascot from './components/clients/client/settings/mascot.vue';
import ClientSettingsBetconstruct from './components/clients/client/settings/betconstruct.vue';
import ClientSettingsBoldplay from './components/clients/client/settings/boldplay.vue';
import ClientSettingsBaas from './components/clients/client/settings/baas.vue';
import ClientSettingsDoubleChanceLotto from './components/clients/client/settings/doublechancelotto.vue';
import ClientSettingsGameProviders from './components/clients/client/settings/game-providers.vue';
import ClientSettingsMpesa from './components/clients/client/settings/mpesa.vue';
import ClientSettingsReferral from './components/clients/client/settings/referral.vue';
import ClientSettingsTaxes from './components/clients/client/settings/taxes.vue';
import ClientSettingsUssd from './components/clients/client/settings/ussd.vue';

import ClientContent from './components/clients/client/content/index.vue';
import ClientContentStrings from './components/clients/client/content/strings/list.vue';
import ClientContentStringsCreate from './components/clients/client/content/strings/create.vue';
import ClientContentStringsEdit from './components/clients/client/content/strings/edit.vue';

import ClientContentLinks from './components/clients/client/content/links/list.vue';
import ClientContentLinksCreate from './components/clients/client/content/links/create.vue';
import ClientContentLinksEdit from './components/clients/client/content/links/edit.vue';

import Branches from './components/clients/client/branches/index.vue';
import BranchList from './components/clients/client/branches/list.vue';
import BranchCreate from './components/clients/client/branches/create.vue';
import Branch from './components/clients/client/branches/branch/index.vue';
import BranchGeneral from './components/clients/client/branches/branch/general.vue';

import BranchBonuses from './components/clients/client/branches/branch/bonuses/index.vue';
import BranchCashbackBonus from './components/clients/client/branches/branch/bonuses/cashback.vue';
import BranchRegistrationBonus from './components/clients/client/branches/branch/bonuses/registration.vue';
import BranchWelcomeBonus from './components/clients/client/branches/branch/bonuses/welcome.vue';
import BranchDepositBonus from './components/clients/client/branches/branch/bonuses/deposit.vue';
import BranchCouponBonus from './components/clients/client/branches/branch/bonuses/coupon.vue';

import BranchGames from './components/clients/client/branches/branch/games/index.vue';
import BranchGamesGeneralSettings from './components/clients/client/branches/branch/games/branch-games-general-settings.vue';
import BranchGamesList from './components/clients/client/branches/branch/games/branch-games-list.vue';

import BranchJackpots from './components/clients/client/branches/branch/jackpots/index.vue';
import BranchJackpotsList from './components/clients/client/branches/branch/jackpots/list.vue';
import BranchJackpotCreate from './components/clients/client/branches/branch/jackpots/create.vue';
import BranchJackpotEdit from './components/clients/client/branches/branch/jackpots/edit.vue';

import BranchPaymentMethods from './components/clients/client/branches/branch/payments/methods.vue';
import BranchBkSettings from './components/clients/client/branches/branch/bk/settings.vue';

import Games from './components/clients/client/games/index.vue';
import GamesGeneral from './components/clients/client/games/general.vue';
import GamesList from './components/clients/client/games/list.vue';
import GamesLists from './components/clients/client/games/lists.vue';
import GamesListsList from './components/clients/client/games/lists-list.vue';
import GamesAgregators from './components/clients/client/games/aggregators.vue';
import GamesAgregator from './components/clients/client/games/aggregator.vue';
import GamesAgregatorSettings from './components/clients/client/games/aggregator-settings.vue';

import PaymentSystem from './components/payment-system/index';
import WithdrawalRequests from './components/payment-system/withdrawal-requests';
import OperationsAwaitingAntiFraud from './components/payment-system/operations-awaiting-antifraud';

import Bonuses from './components/clients/client/bonuses/index.vue';
import BonusesCashback from './components/clients/client/bonuses/cashback.vue';
import BonusesPlaythrough from './components/clients/client/bonuses/playthrough.vue';

import ClientJackpots from './components/clients/client/jackpots.vue';

import ClientMessages from './components/clients/client/messages/index.vue';

import Agents from './components/clients/client/agents/index.vue';
import AgentsList from './components/clients/client/agents/list.vue';
import CreateAgent from './components/clients/client/agents/agent/create.vue';
import Agent from './components/clients/client/agents/agent/index.vue';
import AgentGeneral from './components/clients/client/agents/agent/general.vue';

import Curacao from './components/clients/client/curacao/index.vue';
import CuracaoBalanceReports from './components/clients/client/curacao/balance-reports.vue';

import Kra from './components/clients/client/kra/index.vue';
import KraPayments from './components/clients/client/kra/payments';

import Stats from './components/stats/index.vue';
import StatsProfit from './components/stats/profit.vue';
import StatsProfitMultiple from './components/stats/profit-multiple.vue';
import StatsGames from './components/stats/games.vue';
import StatsTaxes from './components/stats/taxes.vue';

import System from './components/system/index.vue';
import SystemSettings from './components/system/system-settings.vue';
import Currencies from './components/system/currencies.vue';
import PaymentSystemSettings from './components/system/payment-system.vue';

import SystemContent from './components/content/index.vue';
import SystemContentStrings from './components/content/strings/list.vue';
import SystemContentStringsCreate from './components/content/strings/create.vue';
import SystemContentStringsEdit from './components/content/strings/edit.vue';

import SystemContentLinks from './components/content/links/list.vue';
import SystemContentLinksCreate from './components/content/links/create.vue';
import SystemContentLinksEdit from './components/content/links/edit.vue';

import SystemMbk from './components/mbk/index.vue';
import SystemMbkLockedDeposites from './components/mbk/mbk-locked-deposites.vue';

import Login from './components/login.vue';

Vue.use(Router);

export function createRouter() {
    return new Router({
        // NOTE: our product could be integrated on 3thd site
        mode: 'history',

        scrollBehavior(to, from, savedPosition) {
            // NOTE: Returning the savedPosition will result in a native- like behavior when navigating with back/ forward buttons
            if (savedPosition) return savedPosition;
            else return { x: 0, y: 0 };
        },

        routes: [
            {
                path: '/',
                component: Home,
                children: [
                    {
                        path: '',
                        name: 'dashboard',
                        component: Dashboard
                    },
                    {
                        path: '/clients',
                        component: Clients,
                        children: [
                            {
                                path: 'new-client',
                                name: 'client-create',
                                component: ClientCreate
                            },
                            {
                                path: ':clientId(\\d+)',
                                component: Client,
                                meta: { breadcrumb: { routeName: 'players', dynamic: 'client' } },
                                children: [
                                    {
                                        path: 'players',
                                        component: Players,
                                        meta: { breadcrumb: { routeName: 'players', lname: 'Players' } },
                                        children: [
                                            {
                                                path: '',
                                                name: 'players',
                                                component: PlayersList
                                            },
                                            {
                                                path: 'new-player',
                                                name: 'create-player',
                                                component: CreatePlayer,
                                                meta: { breadcrumb: { routeName: 'create-player', lname: 'New player' } }
                                            },
                                            {
                                                path: ':playerId',
                                                component: Player,
                                                meta: { breadcrumb: { routeName: 'player', dynamic: 'player' } },
                                                children: [
                                                    {
                                                        path: '',
                                                        name: 'player',
                                                        component: PlayerGeneral
                                                    },
                                                    {
                                                        path: 'create-balance',
                                                        name: 'create-balance',
                                                        component: CreateBalance
                                                    },
                                                    {
                                                        path: 'transactions',
                                                        name: 'player-transactions',
                                                        component: PlayerTransactions,
                                                        meta: { breadcrumb: { routeName: 'player-transactions', lname: 'Transactions' } }
                                                    },
                                                    {
                                                        path: 'pins',
                                                        name: 'player-pins',
                                                        component: PlayerPins,
                                                        meta: { breadcrumb: { routeName: 'player-pins', lname: 'Pins' } }
                                                    },
                                                    {
                                                        path: 'redpipe-bets',
                                                        name: 'player-redpipe-bets',
                                                        component: PlayerTransBets,
                                                        meta: { breadcrumb: { routeName: 'player-redpipe-bets', lname: 'RedPipe bets' } },
                                                        props: { provider: 'redpipe' }
                                                    },
                                                    {
                                                        path: 'flg-bets',
                                                        name: 'player-flg-bets',
                                                        component: PlayerTransBets,
                                                        meta: { breadcrumb: { routeName: 'player-flg-bets', lname: 'FLG bets' } },
                                                        props: { provider: 'flg' }
                                                    },
                                                    {
                                                        path: 'hdraces-bets',
                                                        name: 'player-hdraces-bets',
                                                        component: PlayerHdRacesBets,
                                                        meta: { breadcrumb: { routeName: 'player-hdraces-bets', lname: 'HdRaces bets' } }
                                                    },
                                                    {
                                                        path: 'bk-bets',
                                                        name: 'player-bk-bets',
                                                        component: PlayerBkBets,
                                                        meta: { breadcrumb: { routeName: 'player-bk-bets', lname: 'BK bets' } }
                                                    },
                                                    {
                                                        path: 'tvbet-bets',
                                                        name: 'player-tvbet-bets',
                                                        component: PlayerTransBets,
                                                        meta: { breadcrumb: { routeName: 'player-tvbet-bets', lname: 'TVBet bets' } },
                                                        props: { provider: 'tvbet' }
                                                    },
                                                    {
                                                        path: 'covid-bets',
                                                        name: 'player-covid-bets',
                                                        component: PlayerTransBets,
                                                        meta: { breadcrumb: { routeName: 'player-covid-bets', lname: 'COVID bets' } },
                                                        props: { provider: 'covid' }
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        path: 'warn',
                                        name: 'client-warn-transactions',
                                        component: ClientWarnTransactions,
                                        meta: { breadcrumb: { routeName: 'client-warn-transactions', lname: 'Warning Transactions' } }
                                    },
                                    {
                                        path: 'pins',
                                        name: 'client-pins',
                                        component: ClientPins,
                                        meta: { breadcrumb: { routeName: 'client-pins', lname: 'Pins' } }
                                    },
                                    {
                                        path: 'bets',
                                        name: 'client-bets',
                                        component: ClientBets,
                                        meta: { breadcrumb: { routeName: 'client-bets', lname: 'Bets' } },
                                        redirect: '/clients/:clientId/bets/redpipe',
                                        children: [
                                            {
                                                path: 'redpipe',
                                                name: 'client-bets-redpipe',
                                                meta: { breadcrumb: { routeName: 'client-bets-redpipe', lname: 'RedPipe' } },
                                                props: { provider: 'redpipe' },
                                                component: ClientTransBets
                                            },
                                            {
                                                path: 'flg',
                                                name: 'client-bets-flg',
                                                meta: { breadcrumb: { routeName: 'client-bets-flg', lname: 'FLG' } },
                                                props: { provider: 'flg' },
                                                component: ClientTransBets
                                            },
                                            {
                                                path: 'hdraces',
                                                name: 'client-bets-hdraces',
                                                meta: { breadcrumb: { routeName: 'client-bets-hdraces', lname: 'HdRaces' } },
                                                component: ClientHdRacesBets
                                            },
                                            {
                                                path: 'bk',
                                                name: 'client-bets-bk',
                                                meta: { breadcrumb: { routeName: 'client-bets-bk', lname: 'Bookmaker' } },
                                                component: ClientBkBets
                                            },
                                            {
                                                path: 'tvbet',
                                                name: 'client-bets-tvbet',
                                                meta: { breadcrumb: { routeName: 'client-bets-tvbet', lname: 'TVBet' } },
                                                props: { provider: 'tvbet' },
                                                component: ClientTransBets
                                            },
                                            {
                                                path: 'covid',
                                                name: 'client-bets-covid',
                                                meta: { breadcrumb: { routeName: 'client-bets-covid', lname: 'Covid' } },
                                                props: { provider: 'covid' },
                                                component: ClientTransBets
                                            }
                                        ]
                                    },
                                    {
                                        path: 'payment-system',
                                        name: 'payment-system',
                                        component: PaymentSystem,
                                        redirect: { name: 'withdrawal-requests' },
                                        children: [
                                            { path: 'withdrawal-requests', name: 'withdrawal-requests', component: WithdrawalRequests },
                                            {
                                                path: 'operations-awaiting-antifraud',
                                                name: 'operations-awaiting-antifraud',
                                                component: OperationsAwaitingAntiFraud
                                            }
                                        ]
                                    },
                                    {
                                        path: 'bonuses',
                                        name: 'client-bonuses',
                                        component: Bonuses,
                                        children: [
                                            {
                                                path: 'cashback',
                                                name: 'client-bonuses-cashback',
                                                component: BonusesCashback,
                                                meta: { breadcrumb: { routeName: 'client-bonuses-cashback', lname: 'Cashback' } }
                                            },
                                            {
                                                path: 'playthrough',
                                                name: 'client-bonuses-playthrough',
                                                component: BonusesPlaythrough,
                                                meta: { breadcrumb: { routeName: 'client-bonuses-playthrough', lname: 'Playthrough' } }
                                            }
                                        ]
                                    },
                                    {
                                        path: 'jackpots',
                                        name: 'client-jackpots',
                                        component: ClientJackpots,
                                        meta: { breadcrumb: { routeName: 'client-jackpots', lname: 'Jackpots' } }
                                    },
                                    {
                                        path: 'settings',
                                        component: ClientSettings,
                                        meta: { breadcrumb: { routeName: 'client-settings-general', lname: 'Settings' } },
                                        children: [
                                            {
                                                path: '',
                                                name: 'client-settings-general',
                                                component: ClientSettingsGeneral,
                                                meta: { breadcrumb: { routeName: 'client-settings-general', lname: 'General' } }
                                            },
                                            {
                                                path: 'view',
                                                name: 'client-settings-view',
                                                component: ClientSettingsView,
                                                meta: { breadcrumb: { routeName: 'client-settings-view-analytics', lname: 'View' } },
                                                redirect: { name: 'client-settings-view-analytics' },
                                                children: [
                                                    {
                                                        path: 'analytics',
                                                        name: 'client-settings-view-analytics',
                                                        component: ClientSettingsViewAnalytics,
                                                        meta: {
                                                            breadcrumb: { routeName: 'client-settings-view-analytics', lname: 'Analytics' }
                                                        }
                                                    },
                                                    {
                                                        path: 'auth',
                                                        name: 'client-settings-view-auth',
                                                        component: ClientSettingsViewAuth,
                                                        meta: { breadcrumb: { routeName: 'client-settings-view-auth', lname: 'Auth' } }
                                                    },
                                                    {
                                                        path: 'banners',
                                                        name: 'client-settings-view-banners',
                                                        component: ClientSettingsViewBanners,
                                                        meta: {
                                                            breadcrumb: { routeName: 'client-settings-view-banners', lname: 'Banners' }
                                                        }
                                                    },
                                                    {
                                                        path: 'bk',
                                                        name: 'client-settings-view-bk',
                                                        component: ClientSettingsViewBk,
                                                        meta: { breadcrumb: { routeName: 'client-settings-view-bk', lname: 'BK' } }
                                                    },
                                                    {
                                                        path: 'bot',
                                                        name: 'client-settings-view-bot',
                                                        component: ClientSettingsViewBot,
                                                        meta: { breadcrumb: { routeName: 'client-settings-view-bot', lname: 'Bot' } }
                                                    },
                                                    {
                                                        path: 'menu',
                                                        name: 'client-settings-view-menu',
                                                        component: ClientSettingsViewMenu,
                                                        meta: { breadcrumb: { routeName: 'client-settings-view-menu', lname: 'Menu' } }
                                                    },
                                                    {
                                                        path: 'general',
                                                        name: 'client-settings-view-general',
                                                        component: ClientSettingsViewGeneral,
                                                        meta: {
                                                            breadcrumb: { routeName: 'client-settings-view-general', lname: 'General' }
                                                        }
                                                    },
                                                    {
                                                        path: 'language',
                                                        name: 'client-settings-view-language',
                                                        component: ClientSettingsViewLanguage,
                                                        meta: {
                                                            breadcrumb: { routeName: 'client-settings-view-language', lname: 'Language' }
                                                        }
                                                    },
                                                    {
                                                        path: 'legal',
                                                        name: 'client-settings-view-legal',
                                                        component: ClientSettingsViewLegal,
                                                        meta: { breadcrumb: { routeName: 'client-settings-view-legal', lname: 'Legal' } }
                                                    },
                                                    {
                                                        path: 'mobile',
                                                        name: 'client-settings-view-mobile',
                                                        component: ClientSettingsViewMobile,
                                                        meta: { breadcrumb: { routeName: 'client-settings-view-mobile', lname: 'Mobile' } }
                                                    },
                                                    {
                                                        path: 'payments',
                                                        name: 'client-settings-view-payments',
                                                        component: ClientSettingsViewPayments,
                                                        meta: {
                                                            breadcrumb: { routeName: 'client-settings-view-payments', lname: 'Payments' }
                                                        }
                                                    },
                                                    {
                                                        path: 'player-activity',
                                                        name: 'client-settings-view-player-activity',
                                                        component: ClientSettingsViewPlayerActivity,
                                                        meta: {
                                                            breadcrumb: {
                                                                routeName: 'client-settings-view-player-activity',
                                                                lname: 'Player activity'
                                                            }
                                                        }
                                                    },
                                                    {
                                                        path: 'profile',
                                                        name: 'client-settings-view-profile',
                                                        component: ClientSettingsViewProfile,
                                                        meta: {
                                                            breadcrumb: { routeName: 'client-settings-view-profile', lname: 'Profile' }
                                                        }
                                                    },
                                                    {
                                                        path: 'routing',
                                                        name: 'client-settings-view-routing',
                                                        component: ClientSettingsViewRouting,
                                                        meta: {
                                                            breadcrumb: { routeName: 'client-settings-view-routing', lname: 'Routing' }
                                                        }
                                                    },
                                                    {
                                                        path: 'style',
                                                        name: 'client-settings-view-style',
                                                        component: ClientSettingsViewStyle,
                                                        meta: { breadcrumb: { routeName: 'client-settings-view-style', lname: 'Style' } }
                                                    },
                                                    {
                                                        path: 'sweepstakes',
                                                        name: 'client-settings-view-sweepstakes',
                                                        component: ClientSettingsViewSweepstakes,
                                                        meta: {
                                                            breadcrumb: {
                                                                routeName: 'client-settings-view-sweepstakes',
                                                                lname: 'Sweepstakes'
                                                            }
                                                        }
                                                    }
                                                ]
                                            },
                                            {
                                                path: 'messengers',
                                                name: 'client-settings-messengers',
                                                component: ClientSettingsMessengers,
                                                meta: { breadcrumb: { routeName: 'client-settings-messengers', lname: 'Messengers' } }
                                            },
                                            {
                                                path: 'bonuses',
                                                name: 'client-settings-bonuses',
                                                component: ClientSettingsBonuses,
                                                meta: {
                                                    breadcrumb: { routeName: 'client-settings-cashback-bonus', lname: 'Bonus settings' }
                                                },
                                                redirect: { name: 'client-settings-cashback-bonus' },
                                                children: [
                                                    {
                                                        path: 'rules-content',
                                                        name: 'client-settings-bonus-rules-content',
                                                        component: ClientSettingsBonusRulesContent,
                                                        meta: {
                                                            breadcrumb: {
                                                                routeName: 'client-settings-bonus-rules-content',
                                                                lname: 'Rules content'
                                                            }
                                                        }
                                                    },
                                                    {
                                                        path: 'cashback',
                                                        name: 'client-settings-cashback-bonus',
                                                        component: ClientSettingsCashbackBonus,
                                                        meta: {
                                                            breadcrumb: { routeName: 'client-settings-cashback-bonus', lname: 'Cashback' }
                                                        }
                                                    },
                                                    {
                                                        path: 'welcome',
                                                        name: 'client-settings-welcome-bonus',
                                                        component: ClientSettingsWelcomeBonus,
                                                        meta: {
                                                            breadcrumb: { routeName: 'client-settings-welcome-bonus', lname: 'Welcome' }
                                                        }
                                                    },
                                                    {
                                                        path: 'deposit',
                                                        name: 'client-settings-deposit-bonus',
                                                        component: ClientSettingsDepositBonus,
                                                        meta: {
                                                            breadcrumb: { routeName: 'client-settings-deposit-bonus', lname: 'Deposit' }
                                                        }
                                                    },
                                                    ,
                                                    {
                                                        path: 'coupon',
                                                        name: 'client-settings-coupon-bonus',
                                                        component: ClientSettingsCouponBonus,
                                                        meta: { breadcrumb: { routeName: 'client-settings-coupon-bonus', lname: 'Coupon' } }
                                                    },
                                                    {
                                                        path: 'registration-bonus',
                                                        name: 'client-settings-registration-bonus',
                                                        component: ClientSettingsRegistrationBonus,
                                                        meta: {
                                                            breadcrumb: {
                                                                routeName: 'client-settings-registration-bonus',
                                                                lname: 'Registration bonus'
                                                            }
                                                        }
                                                    }
                                                ]
                                            },
                                            {
                                                path: 'curacao',
                                                name: 'client-settings-curacao',
                                                component: ClientSettingsCuracao,
                                                meta: { breadcrumb: { routeName: 'client-settings-curacao', lname: 'Curacao' } }
                                            },
                                            {
                                                path: 'gcb',
                                                name: 'client-settings-gcb',
                                                component: ClientSettingsGcb,
                                                meta: { breadcrumb: { routeName: 'client-settings-gcb', lname: 'Gcb' } }
                                            },
                                            {
                                                path: 'referral',
                                                name: 'client-settings-referral',
                                                component: ClientSettingsReferral,
                                                meta: { breadcrumb: { routeName: 'client-settings-referral', lname: 'Referral' } }
                                            },
                                            {
                                                path: 'taxes',
                                                name: 'client-settings-taxes',
                                                component: ClientSettingsTaxes,
                                                meta: { breadcrumb: { routeName: 'client-settings-taxes', lname: 'Taxes' } }
                                            },
                                            {
                                                path: 'ussd',
                                                name: 'client-settings-ussd',
                                                component: ClientSettingsUssd,
                                                meta: { breadcrumb: { routeName: 'client-settings-ussd', lname: 'Ussd' } }
                                            },
                                            {
                                                path: 'kra',
                                                name: 'client-settings-kra',
                                                component: ClientSettingsKra,
                                                meta: { breadcrumb: { routeName: 'client-settings-kra', lname: 'KRA' } }
                                            },
                                            {
                                                path: 'mpesa',
                                                name: 'client-settings-mpesa',
                                                component: ClientSettingsMpesa,
                                                meta: { breadcrumb: { routeName: 'client-settings-mpesa', lname: 'Mpesa' } }
                                            },
                                            {
                                                path: 'registration',
                                                name: 'client-settings-registration',
                                                component: ClientSettingsRegistration,
                                                meta: { breadcrumb: { routeName: 'client-settings-registration', lname: 'Registration' } }
                                            },
                                            {
                                                path: 'login',
                                                name: 'client-settings-login',
                                                component: ClientSettingsLogin,
                                                meta: { breadcrumb: { routeName: 'client-settings-login', lname: 'Login' } }
                                            },
                                            {
                                                path: 'support',
                                                name: 'client-settings-support',
                                                component: ClientSettingsSupport,
                                                meta: { breadcrumb: { routeName: 'client-settings-support', lname: 'Support' } }
                                            },
                                            {
                                                path: 'komplexbridge',
                                                name: 'client-settings-komplexbridge',
                                                component: ClientSettingsKomplexBridge,
                                                meta: { breadcrumb: { routeName: 'client-settings-komplexbridge', lname: 'KomplexBridge' } }
                                            },

                                            {
                                                path: 'payments',
                                                name: 'client-settings-payment-system',
                                                component: ClientSettingsPaymentSystem,
                                                meta: { breadcrumb: { routeName: 'client-settings-payment-system', lname: 'Payments' } }
                                            },
                                            {
                                                path: 'winstats',
                                                name: 'client-settings-winning-stats',
                                                component: ClientSettingsWinningStats,
                                                meta: { breadcrumb: { routeName: 'client-settings-winning-stats', lname: 'Win stats' } }
                                            },
                                            {
                                                path: 'game-proviers',
                                                name: 'client-settings-game-proviers',
                                                component: ClientSettingsGameProviders,
                                                meta: {
                                                    breadcrumb: { routeName: 'client-settings-game-proviers', lname: 'Game providers' }
                                                },
                                                children: [
                                                    {
                                                        path: 'bk',
                                                        name: 'client-settings-bk',
                                                        component: ClientSettingsBk,
                                                        meta: { breadcrumb: { routeName: 'client-settings-bk', lname: 'Bookmaker' } }
                                                    },
                                                    {
                                                        path: 'redpipe',
                                                        name: 'client-settings-redpipe',
                                                        component: ClientSettingsRedPipe,
                                                        meta: { breadcrumb: { routeName: 'client-settings-redpipe', lname: 'RedPipe' } }
                                                    },
                                                    {
                                                        path: 'flg',
                                                        name: 'client-settings-flg',
                                                        component: ClientSettingsFlg,
                                                        meta: { breadcrumb: { routeName: 'client-settings-flg', lname: 'FLG' } }
                                                    },
                                                    {
                                                        path: 'hdraces',
                                                        name: 'client-settings-hdraces',
                                                        component: ClientSettingsHdRaces,
                                                        meta: { breadcrumb: { routeName: 'client-settings-hdraces', lname: 'HdRaces' } }
                                                    },
                                                    {
                                                        path: 'tvbet',
                                                        name: 'client-settings-tvbet',
                                                        component: ClientSettingsTvbet,
                                                        meta: { breadcrumb: { routeName: 'client-settings-tvbet', lname: 'TVBet' } }
                                                    },
                                                    {
                                                        path: 'softgamings',
                                                        name: 'client-settings-softgamings',
                                                        component: ClientSettingsSoftGamings,
                                                        meta: {
                                                            breadcrumb: { routeName: 'client-settings-softgamings', lname: 'SoftGamings' }
                                                        }
                                                    },
                                                    {
                                                        path: 'aviatrix',
                                                        name: 'client-settings-aviatrix',
                                                        component: ClientSettingsAviatrix,
                                                        meta: { breadcrumb: { routeName: 'client-settings-aviatrix', lname: 'Aviatrix' } }
                                                    },
                                                    {
                                                        path: 'galaxsys',
                                                        name: 'client-settings-galaxsys',
                                                        component: ClientSettingsGalaxsys,
                                                        meta: { breadcrumb: { routeName: 'client-settings-galaxsys', lname: 'Galaxsys' } }
                                                    },
                                                    {
                                                        path: 'smartsoft',
                                                        name: 'client-settings-smartsoft',
                                                        component: ClientSettingsSmartsoft,
                                                        meta: { breadcrumb: { routeName: 'client-settings-smartsoft', lname: 'Smartsoft' } }
                                                    },
                                                    {
                                                        path: 'vegas',
                                                        name: 'client-settings-vegas',
                                                        component: ClientSettingsVegas,
                                                        meta: { breadcrumb: { routeName: 'client-settings-vegas', lname: 'Vegas' } }
                                                    },
                                                    {
                                                        path: 'mascot',
                                                        name: 'client-settings-mascot',
                                                        component: ClientSettingsMascot,
                                                        meta: { breadcrumb: { routeName: 'client-settings-mascot', lname: 'Mascot' } }
                                                    },
                                                    {
                                                        path: 'betconstruct',
                                                        name: 'client-settings-betconstruct',
                                                        component: ClientSettingsBetconstruct,
                                                        meta: {
                                                            breadcrumb: { routeName: 'client-settings-betconstruct', lname: 'BetConstruct' }
                                                        }
                                                    },
                                                    {
                                                        path: 'boldplay',
                                                        name: 'client-settings-boldplay',
                                                        component: ClientSettingsBoldplay,
                                                        meta: { breadcrumb: { routeName: 'client-settings-boldplay', lname: 'Boldplay' } }
                                                    },
                                                    {
                                                        path: 'baas',
                                                        name: 'client-settings-baas',
                                                        component: ClientSettingsBaas,
                                                        meta: { breadcrumb: { routeName: 'client-settings-baas', lname: 'Baas' } }
                                                    },
                                                    {
                                                        path: 'doublechancelotto',
                                                        name: 'client-settings-doublechancelotto',
                                                        component: ClientSettingsDoubleChanceLotto,
                                                        meta: {
                                                            breadcrumb: {
                                                                routeName: 'client-settings-doublechancelotto',
                                                                lname: 'DoubleChanceLotto'
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        path: 'content',
                                        component: ClientContent,
                                        meta: { breadcrumb: { routeName: 'client-content-strings', lname: 'Content' } },
                                        children: [
                                            {
                                                path: 'strings',
                                                name: 'client-content-strings',
                                                component: ClientContentStrings,
                                                meta: { breadcrumb: { routeName: 'client-content-strings', lname: 'Strings' } }
                                            },
                                            {
                                                path: 'strings/create',
                                                name: 'client-content-strings-create',
                                                component: ClientContentStringsCreate,
                                                meta: { breadcrumb: { routeName: 'client-content-strings', lname: 'Strings' } }
                                            },
                                            {
                                                path: 'strings/edit/:contentId',
                                                name: 'client-content-strings-edit',
                                                component: ClientContentStringsEdit,
                                                meta: { breadcrumb: { routeName: 'client-content-strings', lname: 'Strings' } }
                                            },
                                            {
                                                path: 'links',
                                                name: 'client-content-links',
                                                component: ClientContentLinks,
                                                meta: { breadcrumb: { routeName: 'client-content-links', lname: 'Links' } }
                                            },
                                            {
                                                path: 'links/create',
                                                name: 'client-content-links-create',
                                                component: ClientContentLinksCreate,
                                                meta: { breadcrumb: { routeName: 'client-content-links', lname: 'Links' } }
                                            },
                                            {
                                                path: 'links/edit/:contentId',
                                                name: 'client-content-links-edit',
                                                component: ClientContentLinksEdit,
                                                meta: { breadcrumb: { routeName: 'client-content-links', lname: 'Links' } }
                                            }
                                        ]
                                    },
                                    {
                                        path: 'games',
                                        name: 'client-games',
                                        component: Games,
                                        meta: { breadcrumb: { routeName: 'client-games-general', lname: 'Games' } },
                                        children: [
                                            {
                                                path: '',
                                                name: 'client-games-general',
                                                meta: { breadcrumb: { routeName: 'client-games-general', lname: 'General' } },
                                                component: GamesGeneral
                                            },
                                            {
                                                path: 'games-lists',
                                                name: 'client-games-lists',
                                                meta: { breadcrumb: { routeName: 'client-games-lists', lname: 'Games lists' } },
                                                component: GamesLists,
                                                children: [
                                                    {
                                                        path: ':listId',
                                                        name: 'client-games-lists-list',
                                                        component: GamesListsList,
                                                        meta: { breadcrumb: { routeName: 'client-games-lists-list', dynamic: 'list' } }
                                                    }
                                                ]
                                            },
                                            {
                                                path: 'game-aggregators/:aggregator',
                                                meta: { breadcrumb: { routeName: 'client-games-aggregator', dynamic: 'game-aggregator' } },
                                                component: GamesAgregators,
                                                children: [
                                                    {
                                                        path: '',
                                                        name: 'client-games-aggregator',
                                                        component: GamesAgregator
                                                    },
                                                    {
                                                        path: 'settings',
                                                        name: 'client-games-aggregator-settings',
                                                        component: GamesAgregatorSettings,
                                                        meta: {
                                                            breadcrumb: { routeName: 'client-games-aggregator-settings', lname: 'Settings' }
                                                        }
                                                    }
                                                ]
                                            },
                                            {
                                                path: ':provider',
                                                name: 'client-games-list',
                                                meta: { breadcrumb: { routeName: 'client-games-list', dynamic: 'game-provider' } },
                                                component: GamesList
                                            }
                                        ]
                                    },
                                    {
                                        path: 'branches',
                                        component: Branches,
                                        meta: { breadcrumb: { routeName: 'branch-list', lname: 'Branches' } },
                                        children: [
                                            {
                                                path: '',
                                                name: 'branch-list',
                                                component: BranchList
                                            },
                                            {
                                                path: 'new-branch',
                                                name: 'branch-create',
                                                component: BranchCreate,
                                                meta: { breadcrumb: { routeName: 'branch-create', lname: 'New branche' } }
                                            },
                                            {
                                                path: ':branch',
                                                component: Branch,
                                                meta: { breadcrumb: { routeName: 'branch-general', dynamic: 'branch' } },
                                                children: [
                                                    {
                                                        path: '',
                                                        name: 'branch-general',
                                                        component: BranchGeneral
                                                    },
                                                    {
                                                        path: 'games',
                                                        name: 'branch-games',
                                                        component: BranchGames,
                                                        meta: { breadcrumb: { routeName: 'branch-games-general', lname: 'Games' } },
                                                        children: [
                                                            {
                                                                path: '',
                                                                name: 'branch-games-general',
                                                                meta: {
                                                                    breadcrumb: { routeName: 'branch-games-general', lname: 'General' }
                                                                },
                                                                component: BranchGamesGeneralSettings
                                                            },
                                                            {
                                                                path: ':provider',
                                                                name: 'branch-games-list',
                                                                meta: {
                                                                    breadcrumb: { routeName: 'branch-games-list', dynamic: 'game-provider' }
                                                                },
                                                                component: BranchGamesList
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        path: 'bonuses',
                                                        name: 'branch-settings-bonuses',
                                                        component: BranchBonuses,
                                                        meta: {
                                                            breadcrumb: {
                                                                routeName: 'branch-settings-cashback-bonus',
                                                                lname: 'Bonus settings'
                                                            }
                                                        },
                                                        redirect: { name: 'branch-settings-cashback-bonus' },
                                                        children: [
                                                            {
                                                                path: 'cashback',
                                                                name: 'branch-settings-cashback-bonus',
                                                                component: BranchCashbackBonus,
                                                                meta: {
                                                                    breadcrumb: {
                                                                        routeName: 'branch-settings-cashback-bonus',
                                                                        lname: 'Cashback'
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                path: 'welcome',
                                                                name: 'branch-settings-welcome-bonus',
                                                                component: BranchWelcomeBonus,
                                                                meta: {
                                                                    breadcrumb: {
                                                                        routeName: 'branch-settings-welcome-bonus',
                                                                        lname: 'Welcome'
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                path: 'deposit',
                                                                name: 'branch-settings-deposit-bonus',
                                                                component: BranchDepositBonus,
                                                                meta: {
                                                                    breadcrumb: {
                                                                        routeName: 'branch-settings-deposit-bonus',
                                                                        lname: 'Deposit'
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                path: 'coupon',
                                                                name: 'branch-settings-coupon-bonus',
                                                                component: BranchCouponBonus,
                                                                meta: {
                                                                    breadcrumb: {
                                                                        routeName: 'branch-settings-coupon-bonus',
                                                                        lname: 'Coupon'
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                path: 'registration-bonus',
                                                                name: 'branch-settings-registration-bonus',
                                                                component: BranchRegistrationBonus,
                                                                meta: {
                                                                    breadcrumb: {
                                                                        routeName: 'branch-settings-registration-bonus',
                                                                        lname: 'Registration bonus'
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        path: 'jackpots',
                                                        component: BranchJackpots,
                                                        meta: { breadcrumb: { routeName: 'branch-jackpot-list', lname: 'Jackpots' } },
                                                        children: [
                                                            {
                                                                path: '',
                                                                name: 'branch-jackpots',
                                                                component: BranchJackpotsList
                                                            },
                                                            {
                                                                path: 'new-jackpot/:type',
                                                                name: 'branch-jackpot-create',
                                                                component: BranchJackpotCreate,
                                                                meta: {
                                                                    breadcrumb: { routeName: 'branch-jackpot-create', lname: 'New jackpot' }
                                                                }
                                                            },
                                                            {
                                                                path: ':jackpotNumber(\\d+)',
                                                                name: 'branch-jackpot-edit',
                                                                component: BranchJackpotEdit,
                                                                meta: {
                                                                    breadcrumb: { routeName: 'branch-jackpot-edit', dynamic: 'jackpot' }
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        path: 'bksettings',
                                                        name: 'branch-bk-settings',
                                                        component: BranchBkSettings,
                                                        meta: { breadcrumb: { routeName: 'branch-bk-settings', lname: 'Bk Settings' } }
                                                    },
                                                    {
                                                        path: 'paymentmethods',
                                                        name: 'branch-paymentmethods',
                                                        component: BranchPaymentMethods,
                                                        meta: {
                                                            breadcrumb: { routeName: 'branch-paymentmethods', lname: 'Payment Methods' }
                                                        }
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        path: 'messages',
                                        name: 'client-messages',
                                        component: ClientMessages,
                                        meta: { breadcrumb: { routeName: 'client-messages', lname: 'Messages' } }
                                    },
                                    {
                                        path: 'agents',
                                        component: Agents,
                                        meta: { breadcrumb: { routeName: 'agents', lname: 'Agents' } },
                                        children: [
                                            {
                                                path: '',
                                                name: 'agents',
                                                component: AgentsList
                                            },
                                            {
                                                path: 'new-agent',
                                                name: 'create-agent',
                                                component: CreateAgent,
                                                meta: { breadcrumb: { routeName: 'create-agent', lname: 'New agent' } }
                                            },
                                            {
                                                path: ':agentId',
                                                component: Agent,
                                                meta: { breadcrumb: { routeName: 'agent', dynamic: 'agent' } },
                                                children: [
                                                    {
                                                        path: '',
                                                        name: 'agent',
                                                        component: AgentGeneral
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        path: 'curacao',
                                        component: Curacao,
                                        meta: { breadcrumb: { routeName: 'client-curacao-balance-reports', lname: 'Curacao' } },
                                        children: [
                                            {
                                                path: '',
                                                name: 'client-curacao-balance-reports',
                                                component: CuracaoBalanceReports
                                            }
                                        ]
                                    },
                                    {
                                        path: 'kra',
                                        component: Kra,
                                        meta: { breadcrumb: { routeName: 'client-kra-payments', lname: 'KRA' } },
                                        children: [
                                            {
                                                path: '',
                                                name: 'client-kra-payments',
                                                component: KraPayments
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'stats',
                        name: 'stats',
                        component: Stats,
                        redirect: 'stats/profit',
                        children: [
                            {
                                path: 'profit',
                                name: 'stats-profit',
                                component: StatsProfit
                            },
                            {
                                path: 'profitMultiple',
                                name: 'stats-profit-mutiple',
                                component: StatsProfitMultiple
                            },
                            {
                                path: 'games',
                                name: 'stats-gamse',
                                component: StatsGames
                            },
                            {
                                path: 'taxes',
                                name: 'stats-taxes',
                                component: StatsTaxes
                            }
                        ]
                    },
                    {
                        path: '/system',
                        component: System,
                        children: [
                            {
                                path: '',
                                name: 'system-settings',
                                component: SystemSettings
                            },
                            {
                                path: 'currencies',
                                name: 'currencies',
                                component: Currencies
                            },
                            {
                                path: 'ps',
                                name: 'payment-system-settings',
                                component: PaymentSystemSettings
                            }
                        ]
                    },
                    {
                        path: '/content',
                        name: 'system-content',
                        component: SystemContent,
                        redirect: '/content/strings',
                        children: [
                            {
                                path: 'strings',
                                name: 'system-content-strings',
                                component: SystemContentStrings
                            },
                            {
                                path: 'strings/create',
                                name: 'system-content-strings-create',
                                component: SystemContentStringsCreate
                            },
                            {
                                path: 'strings/edit/:contentId',
                                name: 'system-content-strings-edit',
                                component: SystemContentStringsEdit
                            },
                            {
                                path: 'links',
                                name: 'system-content-links',
                                component: SystemContentLinks
                            },
                            {
                                path: 'links/create',
                                name: 'system-content-links-create',
                                component: SystemContentLinksCreate
                            },
                            {
                                path: 'links/edit/:contentId',
                                name: 'system-content-links-edit',
                                component: SystemContentLinksEdit
                            }
                        ]
                    },
                    {
                        path: '/mbk',
                        name: 'system-mbk',
                        component: SystemMbk,
                        redirect: '/mbk/locked-deposites',
                        children: [
                            {
                                path: 'locked-deposites',
                                name: 'mbk-locked-deposites',
                                component: SystemMbkLockedDeposites
                            }
                        ]
                    }
                ]
            },
            {
                path: '/login',
                name: 'login',
                component: Login
            },
            {
                path: '**',
                redirect: '/'
            }
        ]
    });
}



// WEBPACK FOOTER //
// ./src/router.js